<template>
  <div class="_footer">
    <ul>
      <li v-for="(item, index) in list" :key="index" @mouseenter="() => item.isShow = !item.isShow"
        @mouseleave="() => item.isShow = !item.isShow">
        <a :href="item.jumpUrl ? item.jumpUrl : 'javascript: void(0)'">{{ item.menuName }}</a>
        <ul class="inner" v-if="item.menuBottomList && item.menuBottomList.length" v-show="item.isShow">
          <li v-for="(i, iindex) in item.menuBottomList" :key="iindex">
            <a :href="i.jumpUrl ? i.jumpUrl : 'javascript: void(0)'" target="_blank">{{ i.menuName }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { getFooterApi } from '@/api/home'
export default {
  created() {
    this.getFooter()
  },
  data() {
    return {
      list: []
    }
  },
  methods: {
    getFooter() {
      getFooterApi().then(res => {
        if (res && res.code === 200) {
          // console.log(res)
          this.list = res.data.map(item => {
            item.isShow = false;
            return item;
          })
        }
      })
    },
    onclick(item) {
      // alert(1)
      item.isShow = true
    }
  }
};
</script>

<style lang="less" scoped>
._footer {
  background-color: #1c6f6e;
  color: #fff;
  font-size: 13px;
  text-align: center;
  height: 60px;
  line-height: 60px;
  padding: 0 20px 0 20px;
  >ul {
    margin: 0 auto;
    float: none;
    display: inline-block;
    min-width: 200px;

    >li {
      float: left;
      position: relative;
      display: block;
      padding: 0 15px;
      cursor: pointer;

      >a {
        color: #fff;
      }
    }
  }

  .inner {
    position: absolute;
    bottom: 60px;
    background-color: #ffffff;
    min-width: 160px;
    position: absolute;
    left: 0;
    z-index: 1000;
    float: left;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    font-size: 14px;
    list-style: none;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    -webkit-box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
    box-shadow: 0 6px 12px rgb(0 0 0 / 18%);

    >li {
      height: 26px;
      line-height: 26px;

      >a {
        text-shadow: 1px 1px 0 #fff;
        display: block;
        padding: 3px 20px;
        clear: both;
        font-weight: normal;
        line-height: 1.428571429;
        color: #333;
        white-space: nowrap;

        &:hover {
          color: #4d75a0;
          background-color: #f1f1f1;
        }
      }
    }
  }

  // //增加哀悼日效果
  // filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  // -webkit-filter: grayscale(100%);
  // -moz-filter: grayscale(100%);
  // -ms-filter: grayscale(100%);
  // -o-filter: grayscale(100%);
  // filter: grayscale(100%);
  // filter: gray;
}
</style>
